module.exports = __webpack_public_path__ + "img/amica.16391f4.png";